module.exports = __webpack_public_path__ + "static/media/RHAInSwing.b843d1be.svg";